import { find, map, sortBy } from "lodash";
import { useEffect, useState } from 'react';

export const useUserSelect = ({ sort = false, options, value }) => {
    const initOptions = sort ? sortBy(map(options, (option, idx) => ({
        value: idx,
        label: option,
    })), 'value') : map(options, (option, idx) => ({
        value: idx,
        label: option,
    }));
    const [optionArr, setOptionArr] = useState(initOptions);
    const [selectedValue, setSelectedValue] = useState(null);

    useEffect(() => {
        setSelectedValue(find(optionArr, (item) => item.value === value) ?? null);
    }, [value]);

    useEffect(() => {
        if (sort) {
            setOptionArr(sortBy([...map(options, (option, idx) => ({ value: idx, label: option }))], 'value'));
        } else {
            setOptionArr([...map(options, (option, idx) => ({ value: idx, label: option }))]);
        }
    }, [options]);

    return { optionArr, selectedValue };
};
